import {
  createSubmission
} from "../../clients/bettercallkyle/BckApi";

export const SUBMISSION_TYPES = {
  CHANGE_REQUEST: 'CHANGE_REQUEST',
  SUPPORT_REQUEST: 'SUPPORT_REQUEST'
}

export const SUBMISSION_TYPES_HUMAN_MAP = {
  [SUBMISSION_TYPES.CHANGE_REQUEST]: 'Change Request',
  [SUBMISSION_TYPES.SUPPORT_REQUEST]: 'Support Request'
}


export const SUBMISSION_TYPES_DESCRIPTIONS = {
  [SUBMISSION_TYPES.CHANGE_REQUEST]: 'Use this when you need us to update text, images, colors, layout, or design elements on your website.',
  [SUBMISSION_TYPES.SUPPORT_REQUEST]: 'Use this when you are experiencing a technical issue or need help troubleshooting a problem.'
}

export const postSubmission = async (type, identifiers, fields, attachments, options) => {
  const response = await createSubmission(type, identifiers, fields, attachments, options)
  return response;
}
